import React, {Component, MouseEvent} from 'react';
import {getSpaceEventTypeName} from 'services/events';
import {LinkIcon, LocationIcon, TimeIcon} from 'components/Icon';
import {SpaceEvent} from 'services/entities/events';
import './index.scss';

interface EventCardProps {
  event: SpaceEvent;
  onClick?: ()=>void;
  cssClass?: string;
  linkVisible?: boolean;
  descriptionVisible?: boolean;
}

export default class EventCard extends Component<EventCardProps> {
  onLinkClick = (ev: MouseEvent) => {
    ev.stopPropagation();
  };

  render() {
    const event = this.props.event;
    const linkVisible = this.props.linkVisible !== false;
    const descriptionVisible = this.props.descriptionVisible !== false;
    return <div className={`event-card ${this.props.cssClass || ''}`} onClick={this.props.onClick}>
      <div className="header">
        <span className="date">
          <span className="week-day">{ event.startTime.format("ddd") }</span>
          <span className="month-day">{ event.startTime.format("Do") }</span>
          <span className="month">{ event.startTime.format("MMM YYYY") }</span>
        </span>
        { event.heroImage && <img src={event.heroImage.toString()} alt="" className="hero" /> }
      </div>
      <div className="body">
        <span className="type">{ getSpaceEventTypeName(event.type) }</span>
        <h3>{ event.name }</h3>
        <span className="time"><TimeIcon /> { event.startTime.format("H:mmA") } - { event.endTime.format("H:mmA") }</span>
        <span className="space"><LocationIcon /> { event.space.name }</span>
        { linkVisible && event.link && <a className="link" href={event.link.toString()} target="_blank" rel="noopener noreferrer" onClick={this.onLinkClick}>
          <LinkIcon /> { event.link.hostname }</a> }
        { descriptionVisible && event.description && <div className="description">{ event.description }</div> }
      </div>
      { this.props.children }
    </div>;
  }
}